/**
 * menu() returns menu json the order
 * @param <String> tag
 * @return <Element> element
 */
const Menu = [{
    title: "Tablero",
    action: "icon icon-home",
    path: "",
},
    {
        title: "Mis Clientes",
        action: "icon icon-user",
        path: "customers",
    },

    {
        title: "Mís Pedidos",
        action: "icon icon-handbag",
        path: "sales",
    },

    {
        title: "Tabla de Precios",
        action: "icon icon-docs",
        path: "pricestable",
    },

];

Menu.forEach(item => {
    if (item.items) {
        item.items.sort((x, y) => {
            let textA = x.title.toUpperCase();
            let textB = y.title.toUpperCase();
            return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
    }
});

export default Menu;